import React, { Component, Fragment } from "react";
import {connect} from 'react-redux';
import {  MDBRow, MDBCol, MDBCard, MDBAvatar, MDBCardBody, MDBIcon, MDBContainer, MDBCardHeader } from "mdbreact";
import AdminNav from "../layout/AdminNavBar";
import {Redirect} from 'react-router-dom';

class Account extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {auth, profile} = this.props;
    if(!auth.uid) return  <Redirect to='/' />
    return (
      <Fragment>
        <AdminNav />
        <MDBContainer className="mt-5 pt-5">
          <MDBRow className="mt-5 mb-5">
            <MDBCol md="8" >
              <MDBCard>
                <MDBCardBody>
                  <MDBCardHeader className="form-header purple-gradient rounded">
                    <h3 className="my-3">My Account</h3>
                  </MDBCardHeader>
                  <MDBAvatar tag="img" className="mx-auto d-block z-depth-1 img-fluid" alt="Sample avatar"
              />
                <h5 className="font-weight-bold mt-4 mb-3 text-center">{profile.firstName} {profile.lastName}</h5>
                <p className="text-uppercase blue-text text-center">{profile.title}</p>
                <p className="grey-text text-center">
                    Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
                    consectetur, adipisci sed quia non numquam modi tempora eius.
                </p>
                <ul className="list-unstyled mb-0 text-center">
                    <a href="#!" className="p-2 fa-lg">
                    <MDBIcon fab icon="facebook-f" className="blue-text" />
                    </a>
                    <a href="#!" className="p-2 fa-lg">
                    <MDBIcon fab icon="twitter" className="blue-text" />
                    </a>
                    <a href="#!" className="p-2 fa-lg">
                    <MDBIcon fab icon="instagram" className="blue-text" />
                    </a>
                </ul>


                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}


export default connect(mapStateToProps)(Account);
